import { Component, Input, OnInit } from "@angular/core";
import { UNIQUE_CAMPAIGN_URL_TAG } from "../../../../shared/models/appData";
import { BrandCampaignFacebookPost } from "../../../../shared/models/brandCampaignFacebookPost";
import { BrandCampaignLinkedInPost } from "../../../../shared/models/brandCampaignLinkedInPost";
import { PostTargetPlatforms } from "../../../../shared/enums/campaignPost.enums";
import { CustomFormValidators } from "../../../../shared/validators/custom-form-validators";

@Component({
  selector: "app-brand-campaign-content-form-fb-landing-page-url",
  templateUrl:
    "./brand-campaign-content-form-fb-landing-page-url.component.html",
  styleUrl: "./brand-campaign-content-form-fb-landing-page-url.component.scss",
})
export class BrandCampaignContentFormFbLandingPageUrlComponent
  implements OnInit
{
  @Input({ required: true }) public post!:
    | BrandCampaignFacebookPost
    | BrandCampaignLinkedInPost;
  @Input() public platform?: PostTargetPlatforms;

  protected readonly LinkedIn = PostTargetPlatforms.LinkedIn;
  protected readonly landingPageUrlValidationPattern = `(${CustomFormValidators.URL_WITH_OBLIGATORY_PROTOCOL_PATTERN})|(^${UNIQUE_CAMPAIGN_URL_TAG}$)`;

  public ngOnInit(): void {
    this.post.link = this.post.link || UNIQUE_CAMPAIGN_URL_TAG;
  }
}
